import ActiveTypeEnum from "@/enums/ActiveTypeEnum";

const enums = {
    SUCCESS: { label: 'Active', value: ActiveTypeEnum.ACTIVE},
    DANGER: { label: 'Inactive', value: ActiveTypeEnum.INACTIVE},
    INFO: { label: 'Not exist', value: ActiveTypeEnum.NOT_EXIST},
};

export default Object.freeze(enums);